import React from 'react';
import { render } from 'react-dom';
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';
import App from './App';

const client = new ApolloClient({
   uri: 'https://graphql-server-spacex.vercel.app/api/graphql',
   // uri: '/graphql',
   cache: new InMemoryCache(),
});

render(
   <ApolloProvider client={client}>
      <App />
   </ApolloProvider>,
   document.getElementById('root')
);
